import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

// react-router-devtools reads window.__REACT_DEVTOOLS_GLOBAL_HOOK__ and calls
// getFiberRoots() on it. Browser extensions, inspectors and preview panes often
// install a partial hook without that method, which throws and replaces the
// whole page with "devTools.getFiberRoots is not a function". Fill in what is
// missing so the overlay's route highlighting degrades instead of crashing.
if (import.meta.env.DEV) {
	const hook = (
		window as unknown as {
			__REACT_DEVTOOLS_GLOBAL_HOOK__?: {
				renderers?: Map<number, unknown>
				getFiberRoots?: (rendererId: number) => Set<unknown>
			}
		}
	).__REACT_DEVTOOLS_GLOBAL_HOOK__
	if (hook) {
		hook.renderers ??= new Map()
		hook.getFiberRoots ??= () => new Set()
	}
}

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
